import { gql } from '@provision/graphql-client';
import { CLIENT_EMAIL_FIELDS } from 'src/graphql/entities/client-email';
import { CLIENT_PHONE_FIELDS } from 'src/graphql/entities/client-phone';
import { META_DATA_SEARCH_QUERY_FIELDS } from 'src/graphql/entities/metadata.fragments';
import { PARTNER_FIELDS, PARTNER_RELATIONS } from 'src/graphql/entities/partner';

export const CLIENT_FIELDS = gql`
  fragment ClientFields on Client {
    id
    clientId
    partnerId
    firstName
    lastName
    notes
    primaryEmail {
      id
      value
    }
    primaryClientEmailId
    primaryClientPhoneNumberId
    marketingOptOut
    createdAt
    updatedAt
    deletedAt
  }
`;

export const CLIENT_RELATIONS = gql`
  fragment ClientRelations on Client {
    id
    partner {
      ...PartnerFields
      ...PartnerRelations
    }
    primaryEmail {
      ...ClientEmailFields
    }
    primaryPhoneNumber {
      ...ClientPhoneFields
    }
    emails {
      ...ClientEmailFields
    }
    phoneNumbers {
      ...ClientPhoneFields
    }
  }
  ${PARTNER_FIELDS}
  ${PARTNER_RELATIONS}
  ${CLIENT_EMAIL_FIELDS}
  ${CLIENT_EMAIL_FIELDS}
  ${CLIENT_PHONE_FIELDS}
`;

export const CLIENT_QUERY_FIELDS = gql`
  fragment ClientQueryFields on ClientDataResponse {
    records {
      ...ClientFields
      ...ClientRelations
      customAttributes @include(if: $hasCustomAttributes)
    }
    metadata {
      ...MetaDataSearchQueryFields
    }
  }
  ${CLIENT_FIELDS}
  ${CLIENT_RELATIONS}
  ${META_DATA_SEARCH_QUERY_FIELDS}
`;
